// extracted by mini-css-extract-plugin
export default {"wrapper":"_80d7eb"};